<template>
    <input type="date" class="w-240 border border-gray-400 outline-none p-1 bg-transparent" :value="display" @input="onInput"/>
</template>
<script>
function leadingZero (f) {
    f = f.toString();
    if (f.length === 0) {
        return '00'
    }
    if (f.length === 1) {
        return '0' + f
    }
    return f
}

export default {
    name: 'datepicker',
    props: {
        value: [Date, String],
        utc: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        dateEntry() {
            if (this.value instanceof Date)
                return this.value

            // convert from string to date
            const d = new Date(this.value)
            if (this.utc)
                return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            return d;
        },
        display() {
            if (this.value == null || this.value === '')
                return ''
            
            // html5 date format should be "YYYY-MM-DDThh:mm"
            const d = this.dateEntry;
            return `${d.getFullYear()}-${leadingZero(d.getMonth() + 1)}-${leadingZero(d.getDate())}`;
        }
    },
    methods: {
        onInput(e) {
            // convert format "2022-06-04T14:13" to dateTime
            const str = e.target.value;
            if (str === '') {
                this.$emit('input', null)
                return
            }
                
            var d = new Date(
                parseInt(str.substr(0, 4)),
                parseInt(str.substr(5, 2)) - 1,
                parseInt(str.substr(8, 2)),
            );
            
            if (this.utc)
                d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            
            // test for an invalid date
            if (isNaN(d))
                return;

            this.$emit('input', d)
        }
    }
}
</script>
